import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { first, firstValueFrom } from 'rxjs';
import { Categoria } from 'src/app/consts/categoria';
import { MensagemResposta } from 'src/app/consts/mensagem';
import { AnexoReformaService } from 'src/app/services/anexo-reforma-service.service';
import { ErrorPageComponent } from 'src/app/shared/custom-components/error-page/error-page.component';
import { SearchPageComponent } from 'src/app/shared/custom-components/search-page/search-page.component';
import { SpinnerComponent } from 'src/app/shared/custom-components/spinner/spinner.component';
import { AdicionarCategoriaComponent } from './adicionar-categoria/adicionar-categoria.component';
import { CategoriasService } from 'src/app/services/categorias.service';

export interface AnexosReforma {
  Id?: number; // vem de RegistroPadrao (ajuste conforme seus campos reais)

  Nome: string;
  Ncm?: string | null;
  Cst: string;
  cClassTrib: string;

  AliquotaIbs: number;
  ReducaoIbs: number;
  AliquotaIbsMunicipal: number;
  ReducaoIbsMunicipal: number;

  AliquotaCbs: number;
  ReducaoCbs: number;

  cClassTribIs: string;
  CstIs: string;

  AliquotaIs: number;

  VigenciaInicio: Date;
  VigenciaFim?: Date | null;

  Descricao: string;

  ListaCategorias: Categoria[];
}


@Component({
  selector: 'app-anexos-reforma',
  templateUrl: './anexos-reforma.component.html',
  styleUrls: ['./anexos-reforma.component.css']
})
export class AnexosReformaComponent implements OnInit, AfterViewInit {

  AnexosForm: FormGroup
  ListaCategorias: Array<Categoria>

  constructor(private AnexoService: AnexoReformaService,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private categoriaService: CategoriasService
  ) {
    this.AnexosForm = this.fb.group({
      Id: 0, // vem de RegistroPadrao (ajuste conforme seus campos reais)
      Nome: [null],
      Ncm: [null],
      Cst: [null],
      cClassTrib: [null],
      AliquotaIbs: 0,
      ReducaoIbs: 0,
      AliquotaIbsMunicipal: 0,
      ReducaoIbsMunicipal: 0,
      AliquotaCbs: 0,
      ReducaoCbs: 0,
      cClassTribIs: [null],
      CstIs: [null],
      AliquotaIs: 0,
      VigenciaInicio: [null],
      VigenciaFim: [null],
      Descricao: [null],
      listaCategorias: this.fb.array([])
    })
  }

  ngOnInit(): void {


  }

  ngAfterViewInit(): void {
  }

  get(id) {
    const dialogRef = this.dialog.open(SpinnerComponent, { panelClass: 'spinner' })
    console.log(id)
    firstValueFrom(this.AnexoService.get(id)).then(
      (response: any) => {
        console.log(response)
        this.AnexosForm.patchValue({
          Id: response.Id, // vem de RegistroPadrao (ajuste conforme seus campos reais)
          Nome: response.Nome,
          Ncm: null,
          Cst: response.Cst,
          cClassTrib: response.cClassTrib,
          AliquotaIbs: response.AliquotaIbs,
          ReducaoIbs: response.ReducaoIbs,
          AliquotaIbsMunicipal: response.AliquotaIbsMunicipal,
          ReducaoIbsMunicipal: response.ReducaoIbsMunicipal,
          AliquotaCbs: response.AliquotaCbs,
          ReducaoCbs: response.ReducaoCbs,
          cClassTribIs: response.cClassTribIs,
          CstIs: response.CstIs,
          AliquotaIs: response.AliquotaIs,
          VigenciaInicio: new Date(response.VigenciaInicio),
          VigenciaFim: new Date(response.VigenciaFim),
          Descricao: response.Descricao,
        })

        this.ListaCategorias = response.ListaCategorias
        this.ListaCategorias = [...response.ListaCategorias];
        dialogRef.close()
      }
    )

  }

  post() {
    const dialogRef = this.dialog.open(SpinnerComponent, { panelClass: 'spinner' })
    console.log(this.AnexosForm.value)
    firstValueFrom(this.AnexoService.post(this.AnexosForm.value)).then(
      (response: MensagemResposta) => {
        if (response) {
          this.abrirPaginaErro('sistema', response);
          if (response[0].Codigo == 'CRM00001') {
            this.limpar();
          }
          dialogRef.close();
        }
      }
    );
  }

  put() {
    const dialogRef = this.dialog.open(SpinnerComponent, { panelClass: 'spinner' })
    console.log(this.AnexosForm.value)
    firstValueFrom(this.AnexoService.put(this.AnexosForm.value)).then(
      (response: MensagemResposta) => {
        if (response) {
          this.abrirPaginaErro('sistema', response);
          if (response[0].Codigo == 'CRM00001') {
            this.get(this.AnexosForm.value.Id)
            this.limpar();
          }
          dialogRef.close();
        }
      }
    );
  }

  postCategoria(categoria) {
    console.log(categoria)
    categoria.AnexoId = null
    const dialogRef = this.dialog.open(SpinnerComponent, { panelClass: 'spinner' })
    firstValueFrom(
      this.categoriaService.post([categoria])
    ).then((response: MensagemResposta[]) => {
      if (response[0].Codigo == 'CRM00001') {
        this.abrirPaginaErro('sistema', response);
        dialogRef.close();

        this.ListaCategorias = this.ListaCategorias.filter(a => a.Id !== categoria.Id)
        this.ListaCategorias = [...this.ListaCategorias];
      }
    }).catch(err => {
      this.abrirPaginaErro('erro', err)
      dialogRef.close();
    });
  }

  pesquisarAnexo() {
    console.log('teste')
    this.limpar();
    const dialogConfig = new MatDialogConfig();

    dialogConfig.data = {
      tabela: 'AnexosReforma',
    };

    this.dialog
      .open(SearchPageComponent, dialogConfig)
      .afterClosed()
      .subscribe((AnexoEscolhido) => {
        if (AnexoEscolhido) {
          this.get(AnexoEscolhido.Id)
        }
      });
  }

  delete() {
    const dialogRef = this.dialog.open(SpinnerComponent, { panelClass: 'spinner' })
    firstValueFrom(
      this.AnexoService.delete(this.AnexosForm.value.Id)
    ).then((response: MensagemResposta) => {
      if (response) {
        this.abrirPaginaErro('sistema', response);
        if (response[0].Codigo == 'CRM00003') {
          this.limpar();
        }
        dialogRef.close();
      }
    });
  }

  limpar() {
    this.AnexosForm.patchValue({
      id: 0, // vem de RegistroPadrao (ajuste conforme seus campos reais)
      Nome: null,
      Ncm: null,
      Cst: null,
      cClassTrib: null,
      AliquotaIbs: 0,
      ReducaoIbs: 0,
      AliquotaIbsMunicipal: 0,
      ReducaoIbsMunicipal: 0,
      AliquotaCbs: 0,
      ReducaoCbs: 0,
      cClassTribIs: null,
      CstIs: null,
      AliquotaIs: 0,
      VigenciaInicio: null,
      VigenciaFim: null,
      Descricao: null,
    });

    this.ListaCategorias = []
    this.ListaCategorias = [...this.ListaCategorias]
  }

  abrirPaginaErro(tipo, mensagem) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.data = {
      tipo: tipo,
      mensagem: mensagem,
    };

    this.dialog.open(ErrorPageComponent, dialogConfig);
  }


}
